import React from 'react'
import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import { CheckCircle } from '@mui/icons-material'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { gDriveDataAtom, gDriveFolderAtom } from './atoms'
import { useGetAllFiles } from '../googleApis/hooks'

export function Second() {
  const { getFiles, canGetFiles } = useGetAllFiles()
  const [googleFolderURL, setGoogleFolderURL] = useAtom(gDriveFolderAtom)
  const setGDriveData = useSetAtom(gDriveDataAtom)
  const getDriveFiles = async () => {
    setGDriveData(await getFiles(googleFolderURL))
  }

  return (
    <Box>
      <p>
        <strong>Second</strong>
      </p>
      <Box sx={{ mb: 2 }}>
        <Typography mb={1}>
          Update Presentations from GoogleDrive Folder (link):
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <TextField
              id="googleDriveFolderUrl"
              value={googleFolderURL}
              onChange={(e) => {
                setGoogleFolderURL(e.target.value)
              }}
              variant="standard"
            ></TextField>
            <CheckCircle
              color={googleFolderURL !== '' ? 'success' : 'disabled'}
            />
          </Box>
          <Button
            variant="contained"
            onClick={() => getDriveFiles()}
            color="primary"
            disabled={googleFolderURL === '' || !canGetFiles}
          >
            Get Files from Drive
          </Button>
        </Stack>
      </Box>
    </Box>
  )
}
